import axios from "axios";
import { authActions } from "_store";
import { toast } from "react-toastify";

const getAuthToken = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.token || null;
  } catch {
    return null;
  }
};

const getAxiosConfig = ({
  token = getAuthToken(),
  contentType = "application/json",
  customHeaders = {},
  params = {},
  timeout = 20000,
} = {}) => ({
  headers: {
    "Content-Type": contentType,
    ...(token && { Authorization: `Bearer ${token}` }),
    ...customHeaders,
  },
  params,
  timeout,
});

const handleError = (error, dispatch) => {
  const message =
    error?.response?.data?.message || error.message || "Unknown error";
  if (message === "Unauthorized") {
    toast.error("Unauthorized session, try to relogin.");
    dispatch(authActions.logout());
  } else {
    toast.error(message);
  }
};

const apiService = {
  get: async (url, dispatch, configOptions = {}) => {
    try {
      const config = getAxiosConfig(configOptions);
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      handleError(error, dispatch);
      return null;
    }
  },

  post: async (url, data, dispatch, configOptions = {}) => {
    try {
      const config = getAxiosConfig(configOptions);
      const response = await axios.post(url, data, config);
      return response.data;
    } catch (error) {
      handleError(error, dispatch);
      return null;
    }
  },

  // Add PUT, DELETE as needed
};

export { apiService };
